// profile
import profilePage from '../pages/profile/ProfilePage.vue'
import profileHistoryPage from '../pages/profile/ProfileHistoryPage.vue'

// single pages
// import homePage from '../pages/Home.vue'
import loginPage from '../pages/auth/Login.vue'
import verifyOTP from '../pages/auth/VerifyOTP'
import forgetPassword from '../pages/password/ForgetPassword.vue'
import forgetPasswordOTP from '../pages/password/ForgetPasswordOTP.vue'
import resetPassword from '../pages/password/ResetPassword.vue'
import resetPasswordSuccess from '../pages/password/ResetPasswordSuccess.vue'
import loanSummary from '../pages/loan/Summary.vue'
import loanDetail from '../pages/loan/Detail.vue'
import supportRequest from '../pages/support/SupportRequest.vue'
import requestSuccess from '../pages/support/RequestSuccess.vue'
import paymentIntroduction from '../pages/payment/Introduction.vue'
import paymentList from '../pages/payment/PaymentList.vue'
import paymentDetail from '../pages/payment/PaymentDetail.vue'
import paymentProcess from '../pages/payment/PaymentProcess.vue'
import paymentSuccess from '../pages/payment/PaymentSuccess.vue'
import paymentResult from '../pages/payment/PaymentResult.vue'
import earlyPaymentList from '../pages/earlyPayment/EarlyPaymentList.vue'
import earlyPaymentDetail from '../pages/earlyPayment/EarlyPaymentDetail.vue'
// import landing from '../pages/Landing'
import landingPage from '../pages/LandingPage'
import notFoundPage from '../pages/NotFound.vue'

import { routePropResolver } from './util'
const DOMAIN_TITLE = process.env.VUE_APP_TITLE

export const routes = [
  {
    path: '/',
    name: 'index',
    component: landingPage,
    meta: { layout: 'blank-layout', title: `${DOMAIN_TITLE} | home` }
  },
  /* {
    path: '/news',
    name: 'news',
    component: newsPage,
    meta: { title: `${DOMAIN_TITLE} | news` },
    props: routePropResolver
  }, */
  {
    path: '/profile',
    name: 'profile',
    component: profilePage,
    meta: { layout: 'app-layout', isAuth: true, title: `${DOMAIN_TITLE} | profile` }
  },
  {
    path: '/profile/history',
    name: 'profileHistory',
    component: profileHistoryPage,
    meta: { layout: 'blank-layout', isAuth: true, title: `${DOMAIN_TITLE} | profile` }
  },
  {
    path: '/auth/login',
    name: 'login',
    component: loginPage,
    meta: { layout: 'simple-layout', title: `${DOMAIN_TITLE} | Login` }
  },
  {
    path: '/auth/otp',
    name: 'verifyOTP',
    component: verifyOTP,
    props: true,
    meta: { layout: 'simple-layout', title: `${DOMAIN_TITLE} | Verify OTP` },
    beforeEnter (to, from, next) {
      if (typeof (to.params.password) !== 'undefined' && to.params.password !== null &&
      typeof (to.params.username) !== 'undefined' && to.params.username !== null
      ) {
        next()
        return
      }
      next('/')
    }
  },
  {
    path: '/password/forget',
    name: 'forgetPassword',
    component: forgetPassword,
    meta: { layout: 'simple-layout', title: `${DOMAIN_TITLE} | Forget Password` }
  },
  {
    path: '/password/otp',
    name: 'forgetPasswordOTP',
    component: forgetPasswordOTP,
    meta: { layout: 'simple-layout', title: `${DOMAIN_TITLE} | Forget Password OTP` },
    beforeEnter (to, from, next) {
      if (typeof (to.params.username) !== 'undefined' && to.params.username !== null) {
        next()
        return
      }
      next('/')
    }
  },
  {
    path: '/password/reset',
    name: 'reset-password',
    component: resetPassword,
    meta: { layout: 'simple-layout', title: `${DOMAIN_TITLE} | Reset Password` },
    beforeEnter (to, from, next) {
      if (typeof (to.params.password) !== 'undefined' && to.params.password !== null &&
        typeof (to.params.username) !== 'undefined' && to.params.username !== null
      ) {
        next()
        return
      }
      next('/')
    }
  },
  {
    path: '/password/reset_success',
    name: 'resetPasswordSuccess',
    component: resetPasswordSuccess,
    meta: { layout: 'simple-layout', title: `${DOMAIN_TITLE} | Reset Password Success` }
  },
  {
    path: '/loan',
    name: 'loanSummary',
    component: loanSummary,
    meta: { layout: 'app-layout', title: `${DOMAIN_TITLE} | Loan Summary`, isAuth: true },
    props: routePropResolver
  },
  {
    path: '/loan/:contractNo',
    name: 'loanDetail',
    component: loanDetail,
    meta: { layout: 'app-layout', title: `${DOMAIN_TITLE} | Loan Detail`, isAuth: true }
  },
  {
    path: '/support',
    name: 'support',
    component: supportRequest,
    meta: { layout: 'app-layout', title: `${DOMAIN_TITLE} | Support Request`, isAuth: true }
  },
  {
    path: '/support/request_success',
    name: 'requestSuccess',
    component: requestSuccess,
    meta: { layout: 'app-layout', title: `${DOMAIN_TITLE} | Request Success`, isAuth: true }
  },
  {
    path: '/payment',
    name: 'paymentIntroduction',
    component: paymentIntroduction,
    meta: { layout: 'app-layout', title: `${DOMAIN_TITLE} | Payment Introduction`, isAuth: true }
  },
  {
    path: '/payment/list',
    name: 'paymentList',
    component: paymentList,
    meta: { layout: 'app-layout', title: `${DOMAIN_TITLE} | Payment List`, isAuth: true }
  },
  {
    path: '/payment/success',
    name: 'paymentSuccess',
    component: paymentSuccess,
    meta: { layout: 'app-layout', title: `${DOMAIN_TITLE} | Payment Success`, isAuth: true }
  },
  {
    path: '/payment/result',
    name: 'paymentResult',
    component: paymentResult,
    meta: { layout: 'app-layout', title: `${DOMAIN_TITLE} | Payment Result`, isAuth: true }
  },
  {
    path: '/payment/:contractNo',
    name: 'paymentDetail',
    component: paymentDetail,
    meta: { layout: 'app-layout', title: `${DOMAIN_TITLE} | Payment Detail`, isAuth: true }
  },
  {
    path: '/payment/process/:contractNo',
    name: 'paymentProcess',
    component: paymentProcess,
    meta: { layout: 'app-layout', title: `${DOMAIN_TITLE} | Payment Process`, isAuth: true }
  },
  {
    path: '/early-payment/list',
    name: 'earlyPaymentList',
    component: earlyPaymentList,
    meta: { layout: 'app-layout', title: `${DOMAIN_TITLE} | Early Payment List`, isAuth: true }
  },
  {
    path: '/early-payment/:contractNo',
    name: 'earlyPaymentDetail',
    component: earlyPaymentDetail,
    meta: { layout: 'app-layout', title: `${DOMAIN_TITLE} | Early Payment Detail`, isAuth: true }
  },
  {
    path: '*',
    component: notFoundPage,
    meta: { layout: 'blank-layout', title: `${DOMAIN_TITLE} | not found` }
  }
]
